import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_8 = { style: {"margin":"0 10px"} }
const _hoisted_9 = {
  key: 0,
  class: "order-details-content"
}
const _hoisted_10 = { style: {"font-size":"17px","width":"750px","padding-bottom":"10px","text-align":"right"} }
const _hoisted_11 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_12 = {
  key: 1,
  class: "loading-indicator"
}

import { ref, onMounted, h, computed } from "vue";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  useNotification,
  useDialog,
  NFormItem,
  NInputGroup,
  NInput,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useAuth } from "@/composables/useAuth";
import { QueryInfo, ChangeStatus } from "@/model/base";
import { Order, OrderItem } from "@/model/order";
import { useOrderApi } from "@/composables/useOrderForm";
import { usePagination } from "@/composables/usePagination";
import { useActionDialog } from "@/composables/useDialog";
const changeOrderStatusFunc = "changeOrderStatus";

export default /*@__PURE__*/_defineComponent({
  __name: 'Order',
  setup(__props) {

const { show: showActionDialog } = useActionDialog();
const { deleteOrder } = useOrderApi();

const { loading } = useAuth(); // 전역 로딩 상태
const router = useRouter();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const pagination = ref<QueryInfo>({
  pageSize: 25,
  lastEvaluatedKey: null,
  previousLastEvaluatedKeys: [],
});

const componentKey = ref(0);
const showOrderDetailsModal = ref(false);
const selectedOrder = ref<Order | null>(null);
const searchValue = ref<string | null>(null);
const searchType = ref("guardian.name");

const getOrdersCallable = getCallable("getPersonalOrders");
const getCallApiCallable = getCallable("callApi");
const setOrderPaymentCallable = getCallable("setOrderPayment");

const searchOptions = [
  // { label: "피검자", value: "products[0].projects[0].examinees[0].name" },
  { label: "보호자", value: "guardian.name" },
];

const {
  paginatedItems: orders,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshOrders,
} = usePagination<Order>(async (params) => getOrdersCallable(params), 25);
async function wrappedRefreshOrders() {
  loading.value = true;
  const searchParams: { searchKey?: string; searchValue?: string } = {};

  if (searchValue.value && searchValue.value.trim() !== "") {
    searchParams.searchKey = searchType.value;
    searchParams.searchValue = searchValue.value.trim();
  }
  await composableRefreshOrders(searchParams);
  loading.value = false;
}
const columns = [
  {
    title: "피검자",
    key: "products.0.projects.0.examinees.0.name",
    resizable: true,
  },
  { title: "보호자", key: "guardian.name", resizable: true },
  { title: "관계", key: "guardian.relationship", resizable: true },

  {
    title: "신청/접수일",
    key: "createdDate",
    resizable: true,
    render: (row: Order) => {
      const timestamp = Number(row.createdDate);
      if (!isNaN(timestamp)) {
        const date = new Date(timestamp);
        return common.getYYYYMMDD2(date);
      }
      return row.createdDate || "N/A";
    },
  },
  {
    title: "금액",
    key: "totalPrice",
    resizable: true,
    render: (row: Order) => `${Number(row.totalPrice || 0).toLocaleString()}원`,
  },
  {
    title: "상태",
    key: "status",
    resizable: true,
    render: (row: Order) => `${common.getStatusString(row.status)}`,
  },
  {
    title: "",
    key: "actions",
    render(row: Order) {
      const buttons: any = [];
      buttons.push(
        h(
          NButton,
          {
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => displayOrderDetails(row),
          },
          { default: () => "상세" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => confirmOrder(row),
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "확정" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => cancelOrder(row.SK),
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "취소" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            type: "error",
            onClick: () => {
              deleteOrder(row.SK, false).then((success) => {
                if (success) {
                  orders.value = orders.value.filter((order) => order.SK !== row.SK);
                }
              });
            },
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "삭제" }
        )
      );
      return buttons;
    },
  },
];

const orderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  //   {
  //     title: "가격",
  //     resizable: true,
  //     render: (row: OrderItem) => `${Number(row.price || 0).toLocaleString()}원`,
  //   },
];
async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}
async function displayOrderDetails(order: Order) {
  selectedOrder.value = order;
  showOrderDetailsModal.value = true;
}

function closeOrderDetailsModal() {
  showOrderDetailsModal.value = false;
}

function onOrderDetailsModalClose() {
  showOrderDetailsModal.value = false;
  selectedOrder.value = null;
}

async function changeOrderStatus(orderSK: string, status: constant.orderStatus) {
  let job: string | null = null;
  if (status == constant.orderStatus.READY) {
    job = "확정";
  } else if (status == constant.orderStatus.CANCELED) {
    job = "취소";
  } else {
    return;
  }
  showActionDialog({
    title: `신청 ${job}`,
    content: `이 신청을 ${job} 하시겠습니까? ${job} 후에는 수정할 수 없습니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: `${job} 중..`,
    onConfirm: async () => {
      const data: ChangeStatus = {
        SK: orderSK,
        status: status,
      };
      const payload: {
        status: constant.orderStatus;
        type: constant.orderType;
        data: ChangeStatus;
      } = {
        status: status,
        type: constant.orderType.INDIVIDUAL,
        data: data,
      };

      const result = await getCallApiCallable(makeCallApiParam(changeOrderStatusFunc, payload));
      if (common.evalFunctionResult(result)) {
        message.success(`신청이 성공적으로 ${job} 되었습니다.`);
        const orderIndex = orders.value.findIndex((o) => o.SK === orderSK);
        if (orderIndex !== -1) {
          orders.value[orderIndex].status = status;
        }
      } else {
        message.success(common.getResultError(result) || `신청 ${job} 중 오류가 발생했습니다.`);
      }
    },
  });
}

async function cancelOrder(orderSK: string) {
  changeOrderStatus(orderSK, constant.orderStatus.CANCELED);
}

async function confirmOrder(order: Order) {
  const orderSK: string = order.SK!;
  if (!order.is_paid) {
    showActionDialog({
      title: "확인",
      content: "결제(입금확인) 처리 진행 후 확정을 진행 하시겠습니까?",
      positiveText: "네",
      negativeText: "아니요",
      positiveButtonProps: { type: "error" },
      confirmButtonLoadingText: "처리 중...",
      onConfirm: async () => {
        try {
          const result = await setOrderPaymentCallable({ SK: orderSK });
          if (common.evalFunctionResult(result)) {
            changeOrderStatus(orderSK, constant.orderStatus.READY);
          } else {
            throw new Error(common.getResultError(result) || "결제(입금확인) 처리 중 오류가 발생했습니다.");
          }
        } catch (error: any) {
          console.error("결제(입금확인) 처리 API 호출 실패:", error);
          message.error(common.getResultError(error) || "결제(입금확인) 처리 중 오류가 발생했습니다.");
        }
      },
      onCancel: () => {
        changeOrderStatus(orderSK, constant.orderStatus.READY);
      },
    });
  } else {
    changeOrderStatus(orderSK, constant.orderStatus.READY);
  }
}

onMounted(() => {
  wrappedRefreshOrders(); // 초기 데이터 로드
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NSpace), { vertical: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("div", { style: {"font-size":"20px","font-weight":"bold"} }, "검사 신청 관리", -1)
                ])),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _createVNode(_unref(NSpace), {
                vertical: "",
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    align: "baseline",
                    "item-style": "display: flex;"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NFormItem), {
                        label: "검색",
                        style: {"min-width":"350px"},
                        "label-placement": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInputGroup), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NSelect), {
                                value: searchType.value,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event)),
                                options: searchOptions,
                                style: {"width":"120px"}
                              }, null, 8, ["value"]),
                              _createVNode(_unref(NInput), {
                                value: searchValue.value,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
                                placeholder: "검색어를 입력하세요",
                                clearable: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), {
                        style: {"min-width":"300px"},
                        "label-placement": "left"
                      }),
                      _createVNode(_unref(NFormItem), { style: {"margin-bottom":"0"} }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NButton), {
                            type: "primary",
                            onClick: wrappedRefreshOrders
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode(" 조회 ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(Loading, null, null, 512), [
                [_vShow, _unref(loading)]
              ]),
              _createElementVNode("div", null, [
                (_unref(listLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "신청 목록을 불러오는 중..."))
                  : _createCommentVNode("", true),
                (_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
                  : _createCommentVNode("", true),
                (!_unref(listLoading) && !_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_unref(orders).length > 0)
                          ? (_openBlock(), _createBlock(_unref(NDataTable), {
                              key: 0,
                              columns: columns,
                              data: _unref(orders),
                              pagination: false,
                              bordered: true
                            }, null, 8, ["data"]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_6, "등록된 신청이 없습니다."))
                      ]),
                      (_unref(orders).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToPreviousPage,
                              disabled: _unref(currentPage) === 1,
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode(" 이전 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToNextPage,
                              disabled: !_unref(hasNextPage)
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode(" 다음 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: showOrderDetailsModal.value,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showOrderDetailsModal).value = $event)),
            preset: "card",
            style: {"width":"800px"},
            title: "신청 상세 정보",
            onAfterLeave: onOrderDetailsModalClose
          }, {
            default: _withCtx(() => [
              (selectedOrder.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_unref(NSpace), null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, " 신청 / 접수일 : " + _toDisplayString(common.getYYYYMMDD2(new Date(Number(selectedOrder.value.createdDate)))), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 2,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "피검자명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.products![0].projects![0].examinees![0].name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "수신자 이메일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.receiver_email || "검사 시 입력"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "학교 정보",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.products![0].projects![0].examinees![0].school_info || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "우편번호" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.products![0].projects![0].examinees![0].address!.postCode || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "주소" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.products![0].projects![0].examinees![0].address!.address || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "상세 주소",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.products![0].projects![0].examinees![0].address!.addressDetail || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "보호자명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.guardian!.name || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "관계" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.guardian!.relationship || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "검사 상태",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getStatusString(selectedOrder.value.status)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "결제 방법",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.value.payment_method?.type || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 0,
                              label: "결제 계좌",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 1,
                              label: "입금자명",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.deposit_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "금액",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(Number(selectedOrder.value.totalPrice || 0).toLocaleString()) + " 원", 1)
                          ]),
                          _: 1
                        }),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 2,
                              label: "입금예정일",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_date), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _cache[13] || (_cache[13] = _createElementVNode("h4", { style: {"margin-top":"20px","margin-bottom":"10px"} }, "신청 항목", -1)),
                    _createVNode(_unref(NDataTable), {
                      columns: orderItemColumns,
                      data: selectedOrder.value.products,
                      pagination: false,
                      bordered: true,
                      size: "small"
                    }, null, 8, ["data"]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(NButton), {
                        onClick: closeOrderDetailsModal,
                        type: "tertiary",
                        style: {"margin-right":"10px"}
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode(" 닫기 ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_unref(NButton), {
                        type: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (confirmOrder(selectedOrder.value))),
                        disabled: selectedOrder.value.status !== constant.orderStatus.PENDING,
                        style: {"margin-right":"10px"}
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode(" 신청확정 ")
                        ])),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(NButton), {
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (cancelOrder(selectedOrder.value.SK))),
                        disabled: selectedOrder.value.status !== constant.orderStatus.PENDING
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode(" 신청취소 ")
                        ])),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, "상세 정보를 불러오는 중..."))
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})